module.exports = __webpack_public_path__ + "media/images/noticeboard-d79f97b9292ce2d4382b8ee318dd569e.png";